<template>
  <pt-adult-sell-order-progress class="pt-adult-sell-order-progress__withData"></pt-adult-sell-order-progress>
</template>

<script>
import PtAdultSellOrderProgress from './index'
export default {
  name: 'pt-adult-sell-order-progress__withData',
  components: {
    'pt-adult-sell-order-progress': PtAdultSellOrderProgress
  }
}
</script>
